<template
  ><!-- 23:疯狂捉娃娃 24:大家来找茬 -->
  <div class="createPlayStep">
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="120px">
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input v-model="ruleForm.activityName" maxlength="50" show-word-limit placeholder="请填入活动名称" style="width: 340px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天 <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>

          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="backgroundOpacity || isStartEdit"
              @change="handleActivityObj"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" disabled style="margin-left:16px">{{
                  peopleList.length == 0
                    ? "选择人群"
                    : `已选${peopleList.length}个`
                }}</el-button>
              </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="light" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #ccc;
                "
              >
                <span style="color:#999">新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="backgroundOpacity || isStartEdit"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="赠送游戏机会:" required>
            初始赠送
            <el-input :disabled="isStartEdit" v-model="ruleForm.giveTimes" @input="ruleForm.giveTimes = checkputn($event, '0')" style="width:70px" placeholder="请输入"></el-input>
            次机会
            <el-tooltip class="item" effect="light" style="color:#ccc !important" content="活动期间赠送给用户游戏次数" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <template v-if="activityData.id == 24">
            <el-form-item label="游戏时间:" required>
              <el-input :disabled="isStartEdit" v-model="ruleForm.gameTime" @input="ruleForm.gameTime = checkputn($event, '0')" style="width:70px" placeholder="请输入"></el-input>
              秒
            </el-form-item>

            <el-form-item label="游戏模板:" required class="zindexBox">
              <el-radio-group v-model="ruleForm.templateType" :disabled="isStartEdit">
                <el-radio :label="0">默认全部</el-radio>
                <el-radio :label="1">指定模板</el-radio>
              </el-radio-group>
              <el-button :style="{ width: '110px', margin: ' 0 0px 0 15px' }" @click="gamePopup = true" :disabled="ruleForm.templateType == 0 || isStartEdit">
                {{ `已选${gameTemplateList.length}个` }}
              </el-button>
              <el-tooltip class="item" effect="light" content="用户每次游戏的模板系统会随机分配，同一个用户可能会出现重复的模板" placement="bottom">
                <el-button type="text" style="width:35px">
                  <i class="el-icon-warning" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
          <div style="margin-left: -8px;margin-bottom: 10px;font-size: 14px;margin-top: 30px;width: 117px;">做任务得游戏机会:</div>
          <el-form-item label="每日任务:" style="margin-left: 70px;margin-top: -32px;">
            <div @click="addCoupon(1)" class="add_btn1">
              <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
              添加任务
            </div>
            <div class="rule_box" style="width:100%;color:#333">
              <div class="rule_box_content" v-for="(item, i) in taskList1" :key="item.taskType">
                <div class="taskbox">
                  任务分类：{{ detailexplain(item, 1) }}
                  <div class="taskbox-content">
                    <span class="taskbox_edit" @click="editTaskdeail(item, i, 1)" >修改</span>
                    <span class="taskbox_edit" @click="changeSort(i, 0, 1)" v-if="i != 0" >上移</span>
                    <span class="taskbox_edit" @click="changeSort(i, 1, 1)" v-if="i != taskList1.length - 1" >下移</span>
                    <span class="taskbox_del" @click="changedelet(i, 1)" >删除</span>
                  </div>
                </div>
                <div>任务有效期：{{ item.taskValidity == 1 ? "长期有效" : `${item.startTime} ~ ${item.endTime}` }}</div>
                <div v-if="item.taskType == 3">浏览时间：{{ item.viewTime }}秒</div>
                <div v-if="item.taskType == 4">加购商品数：{{ item.addCartLimit }}个</div>
                <div style="word-break: break-word;" v-if="item.taskType == 5">跳转链接：{{ item.jumpUrl }}</div>
                <div>任务说明：{{ detailexplain(item, 2) }}</div>
                <div v-if="item.taskType == 3 || item.taskType == 4">
                  {{ item.taskType == 3 ? "浏览" : "加购" }}商品：
                  <el-button style="width: 155px; margin: 0 15px"> 已选择{{ item.itemList ? item.itemList.length : 0 }}个 </el-button>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动任务:" style="margin-left: 70px;">
            <div @click="addCoupon(2)" class="add_btn1">
              <!-- <img style="width:24px" src="../../assets/images/add.svg" alt="" /> -->
              添加任务
            </div>
            <div class="rule_box" style="width:100%;color:#333">
              <div class="rule_box_content" v-for="(item, i) in taskList2" :key="item.taskType">
                <div class="taskbox">
                  任务分类：{{ detailexplain(item, 1) }}
                  <div class="taskbox-content">
                    <span class="taskbox_edit" @click="editTaskdeail(item, i, 2)">修改</span>
                    <span class="taskbox_edit" @click="changeSort(i, 0, 2)" v-if="i != 0">上移</span>
                    <span class="taskbox_edit" @click="changeSort(i, 1, 2)" v-if="i != taskList2.length - 1">下移</span>
                    <span class="taskbox_del" @click="changedelet(i, 2)">删除</span>
                  </div>
                </div>
                <div>任务有效期：{{ item.taskValidity == 1 ? "长期有效" : `${item.startTime} ~ ${item.endTime}` }}</div>
                <div style="word-break: break-word;" v-if="item.taskType == 7">开卡链接：{{ item.jumpUrl }}</div>
                <div v-if="item.taskType == 8">邀请上限人数：{{ item.inviteLimit }}个</div>
                <div>任务说明：{{ detailexplain(item, 2) }}</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="../../assets/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <el-table
              :data="prizeSettingList"
              style="width: 100%; border: 1px solid #f0f0f0"
              :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" @click="centerVis(scope.row)">选奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">淘宝E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">淘宝PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">专属商品</span>
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price"> </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" maxlength="12" show-word-limit style="width: 240px" :disabled="isStartEdit"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot="header">
                  <span>奖品总数</span>
                  <el-popover
                    placement="top-start"
                    offset="100"
                    trigger="hover"
                    content="奖品总量是控制奖品最多发放份数，达到设置数值后不再发放此奖品；"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    @blur="beAdd(scope.row)"
                    v-model.number="scope.row.totalAmount"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.totalAmount = getNumberData($event, 0)"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="中奖率" width="120px">
                <template slot="header">
                  <span>中奖率</span>
                  <el-popover
                    placement="top-start"
                    width="480"
                    offset="100"
                    trigger="hover"
                    content="中奖总概率可设置区间为0%至100%。本软件中奖概率是按数学中的概率统计学来计算的，并非硬性指标。 比如概率为1%，并非100次抽奖有且只有1次中奖，也不是第100次抽奖才会中奖。 而是每一次抽奖的机率都是平等的，第一次抽是1%,第100次、1万次抽也是1%。 举个现实中抽奖的例子，抽奖箱中有100个球，其中1个是红球代表中奖，其它99个是白球代表不中奖，每一次只能从中抽取1个球， 抽完后再放入箱中，下一个人再来抽(即每次抽奖箱中都有100个球，保证每次抽奖的概率平等性)，这样有可能第1个抽奖的就抽中了红球，或有可能第100个抽奖的都没抽中，也或100个人抽了已经有3个抽中了红球都有可能，都是属于统计学的概率问题。"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    :disabled="isStartEdit"
                    v-model="scope.row.percentage"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="scope.row.percentage = oninput2(scope.row.percentage)"
                    @input="scope.row.percentage = getNumberData($event, 1, 0, 100)"
                  ></el-input>
                  %
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot="header">
                  <span>图片</span>
                  <el-popover
                    placement="top-start"
                    width="400"
                    offset="100"
                    trigger="hover"
                    content="图片显示在抽奖页面的奖品展示区域，建议图片宽高为200px*200px图片必须为jpg和png格式，小于300KB;"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 56px; height: 56px" />
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="s" style="color:#F56C6C" @click="cleanData(scope.row)">清除</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="tips">
              <span> <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i>说明 </span>
              <p>
                1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
              </p>
              <p>
                2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
              </p>
              <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
              <p>
                4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
              </p>
            </div>
          </el-form-item>
          <template v-if="activityData.id == 23">
            <el-form-item label="容错机会:" required>
              初始赠送
              <el-input
                :disabled="isStartEdit"
                v-model="ruleForm.faultTimes"
                maxlength="3"
                @input="ruleForm.faultTimes = checkputn($event, '10')"
                style="width:70px"
                placeholder="请输入"
              ></el-input>
              次机会
              <el-tooltip class="item" effect="light" style="color:#ccc !important" content="每次游戏允许用户夹不到的次数" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="抽奖分值:" required>
              满
              <el-input
                :disabled="isStartEdit"
                v-model="ruleForm.scoreLimit"
                @change="handleLimit"
                @input="ruleForm.scoreLimit = checkputn($event, '0')"
                style="width:70px"
                placeholder="请输入"
              ></el-input>
              分，可参与抽奖
              <el-tooltip class="item" effect="light" style="color:#ccc !important" content="夹中一个娃娃得分为10分" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-warning"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
          <el-form-item label="抽奖条件:" required v-if="activityData.id == 24">
            找出图片中的全部不同方可参与抽奖
          </el-form-item>
          <el-form-item label="中奖限制:">
            活动期间每人每天中奖不超过&nbsp;<el-input
              @input="ruleForm.oneDayMaxRewardNumber = checkputn($event, '0')"
              style="width:60px"
              @change="orderChange"
              v-model="ruleForm.oneDayMaxRewardNumber"
              placeholder="请输入"
              :disabled="isStartEdit"
            ></el-input
            >&nbsp; 次，累计中奖不超过&nbsp;
            <el-input
              :disabled="isStartEdit"
              @input="ruleForm.totalMaxRewardNumber = checkputn($event, '0')"
              @change="orderChange"
              style="width:60px"
              v-model="ruleForm.totalMaxRewardNumber"
              placeholder="请输入"
            ></el-input
            >&nbsp; 次，奖品有限，先到先得
          </el-form-item>
          <el-form-item label="曝光商品:" class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch" @change="exposureSwitchChange" :disabled="!isSave">
              是否添加曝光商品
            </el-checkbox>
            <el-button style="width: 155px; margin: 0 15px" @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false">
              {{ itemListFor.length != "" ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")" : "添加曝光商品" }}
            </el-button>
            <!-- <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false">
              <el-radio :label="0">显示淘宝价</el-radio>
              <el-radio :label="1">显示促销价</el-radio>
            </el-radio-group> -->
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px 10px 0px 10px;"
            >
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <!-- <div @click.stop="delec(index)" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div> -->
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(item, index)" class="delectIcom" />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length : 0 }}/2000）
              </div>
              <div>
                <el-button type="primary" class="generate" plain @click="generateRule" :disabled="backgroundOpacity">
                  生成规则
                </el-button>

                <span class="desc">
                  <i class="el-alert__icon el-icon-info" style="color:#999"></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button v-show="!itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button v-show="itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="cancelEdit">取消</el-button>
      <el-button v-show="itemId" class="createBtn create_bottom_keepBtn" type="primary" size="medium">保存设置</el-button>
    </div>
    <!-- 添加曝光商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor> -->
    <!-- 选择商品组件  -->
    <selectGoodsMonitor v-if="selectGoodsState" @transferName="selectGoodsClose" :postForm="selectGoodsArr" :maxNum="20"></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" :num="1" :JingdouCount="JingdouCount" @choose-shop="getTheData"> </selectProduct>
    <!-- 每日任务弹窗 -->
    <dailytask
      :timeDate="activityTimeValue"
      :ActivityIsAdd="ActivityIsAdd"
      :taskItem="taskItem"
      :disabledtask="disabledtask"
      :ActivityType="taskSeletFlay"
      v-if="dailytaskFlay"
      @handleChoice="handleChoice"
      @handleChoiceEdit="handleChoiceEdit"
    ></dailytask>

    <!-- 确定礼包模板弹窗 -->
    <game-popup :gameTemplateList="gameTemplateList" :giftList="giftList" @handleTemplate="handleTemplate" v-if="gamePopup" />
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
// import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import selectGoodsMonitor from "@/components/select-goods2";
import draggable from "vuedraggable";
import dailytask from "./Dailytask.vue";
import { editGameHub, createGameHub, getGameHub, getGameTemplate } from "@/api/paradiseAndTaskCommonController.js";
import gamePopup from "./gamePopup.vue";
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    dailytask,
    gamePopup,
  },
  // props: {
  //   itemId: "",
  //   stepNum: {
  //     type: Number,
  //     default: 0,
  //   },
  //   activeValue: {
  //     type: Number,
  //   },
  //   valueRow: null,
  //   activityData: {
  //     type: Object,
  //   },
  //   isSave: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   statusComment: {
  //     type: Boolean,
  //     default: false,
  //   },
  //   backgroundOpacity: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });

      this.winningRate = this.winningRate.toFixed(3);
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      isStartEditTime:'',
      isStartEdit:false,
      generalCoupon: { // 通用优惠券
        couponType: 0,
      },
      isCopy: false,
      valueRow: null,
      telCode: "",
      localStep: 1,
      statusComment: false,
      localStepNum: 0,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();
        },
      },
      // topindex: 0,
      gameTemplateList: [],
      gamePopup: false,
      taskItem: {},
      disabledtask: [],
      edittaskIndex1: 0,
      edittaskIndex2: 0,
      ActivityIsAdd: false, // 新增 修改
      taskSeletFlay: true, // 每日活动 活动任务
      taskList1: [], //每日任务
      taskList2: [], // 活动任务
      dailytaskFlay: false,
      JingdouCount: {
        prizeCount: 0,
      },
      winningRate: 0,
      theNum: 0,
      index: 0,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      levelList: [],
      disableTime: false,
      qrcode: null,
      order: "",
      //时间限制
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      ruleForm: {
        membershipTime:"",
        //设置规则表单
        activityName: "",
        activityObject: 0, //活动对象
        newOldCustomer: 0, //新老客
        partner: ["-1"],
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        activityRulesText: "", //生成规则
        // 抓娃娃 找茬
        totalMaxRewardNumber: "", //活动期间最大中奖次数
        oneDayMaxRewardNumber: "", //每人每天最大中奖次数
        giveTimes: 5, //赠送游戏机会
        faultTimes: 5, //容错机会
        scoreLimit: "", //分数下限限制
        gameTime: 90, //游戏时间，单位秒
        templateType: 0, //游戏模板类型 0全部 1指定
        templateIds: "", //
        itemList: [], //曝光商品集合
      },
      peopleList: [], //指定人群
      isShowSelectCrowd: false, //指定人群弹窗
      levelList: [], //会员等级
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },
  created() {
    this.activityData = this.$route.query.activityData;
    this.localStepNum = this.activityData.id;
    console.log('this.$route.query------>', this.$route.query)
    console.log('this.localStepNum------>', this.localStepNum)
    if (this.$route.query.valueRow) {
      this.backgroundOpacity = this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment = this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.getRedParker();
    } else if (this.$route.query.copyParams) { // 复制
      this.isCopy = true
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.getRedParker();
    } else {
      this.activityTimeChange();
    }
    // 数据初始化
    this.getPolite();
    this.getLevel()
  },
  mounted() {
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    // 数据初始化
    async getPolite() {
      if (this.activityData.id == 24) {
        const { data } = await getGameTemplate();
        this.giftList = data.map((item) => ({
          ...item,
          checked: false,
          days: item.templateType == 2 ? this.getDaysBetween(item.appointTimeStart, item.appointTimeEnd) : "",
        }));
      }
    },
    // 数据回显
    getRedParker() {
      getGameHub(this.valueRow.id).then((res) => {
        console.log(res, 5555);
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        
        if(this.isStartEdit){
          //进行中活动 无法修改活动开启时间
          this.isStartEditTime = String(res.data.startTime)
        }

        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.activityRulesText = this.isCopy ? "" : String(res.data.ruleDescription); //生成规则

        this.ruleForm.activityObject = res.data.activityObject || 0;
        this.ruleForm.newOldCustomer = res.data.newOldCustomer || 0;
        if (res.data.allowLevel) {
          this.ruleForm.partner = res.data.allowLevel.split(",");
        }
        this.ruleForm.membershipTime = res.data.membershipTime
        // this.ruleForm.partner = res.data.allowLevel.split(",");
        // this.ruleForm.condFollow = res.data.condFollow == 1 ? true : false;
        this.ruleForm.radio = res.data.priceType; // 0：显示淘宝价 1：显示促销价 ,
        this.ruleForm.oneDayMaxRewardNumber = res.data.ruleDTO.oneDayMaxRewardNumber;
        this.ruleForm.totalMaxRewardNumber = res.data.ruleDTO.totalMaxRewardNumber;
        this.ruleForm.giveTimes = res.data.ruleDTO.giveTimes;
        if (this.activityData.id == 23) {
          this.ruleForm.faultTimes = res.data.ruleDTO.faultTimes;
          this.ruleForm.scoreLimit = res.data.ruleDTO.scoreLimit;
        }
        if (this.activityData.id == 24) {
          this.ruleForm.gameTime = res.data.ruleDTO.gameTime;
          this.ruleForm.templateType = res.data.ruleDTO.templateType;
          this.gameTemplateList = res.data.ruleDTO.templateType == 1 ? res.data.gameTemplateId.split(",") : [];
          if (res.data.ruleDTO.templateType == 1 && this.backgroundOpacity) {
            this.giftList = res.data.gameTemplateList.map((item) => ({
              ...item,
              checked: false,
              // days: item.templateType == 2 ? this.getDaysBetween(item.appointTimeStart, item.appointTimeEnd) : "",
            }));
          }
        }
        if(res.data.taskList) {
          this.taskList1 = res.data.taskList.filter((val) => val.activityType == 1);
          this.taskList2 = res.data.taskList.filter((val) => val.activityType == 2);
        }
        // this.ruleForm.giveTimes = res.data.ruleDTO.giveTimes;
        // 奖品
        if (!this.isCopy) {
          this.prizeSettingList = res.data.integralParadisePrizeDTOS;
          this.prizeSettingList.forEach(item=>item.minNum=item.totalAmount)
          this.prizeSettingList.forEach((item, index) => {
            item.index = index;
            if (item.percentage) {
              this.winningRate += Number(item.percentage);
            }
          });
        } else {
          this.prizeSettingList = [
            // 奖项设置
            {
              index: 0,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 1,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 2,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 3,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 4,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 5,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 6,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
            {
              index: 7,
              prizeType: 9,
              price: null,
              title: "谢谢参与",
              totalAmount: null,
              percentage: null,
            },
          ]
        }
        
        this.winningRate = this.isCopy ? 0 : this.winningRate.toFixed(3);
        //曝光商品
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
      });
    },
    //清除
    cleanData(row) {
      if(this.isStartEdit) return;
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },

    // 活动进行中修改奖品数量
    beAdd(row){
      console.log("活动进行中修改奖品数量",row);
      if(this.isStartEdit){
        if(row.minNum && Number(row.totalAmount) < Number(row.minNum)){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if(data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data))
      } else {
        this.generalCoupon = { couponType: 0 }
      }

      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].singleAmount = 1;
        this.prizeSettingList[this.index].quota = data.quota;
        if(data.couponType == 4) {
          this.prizeSettingList[this.index].batchKey = data.batchKey;
        }
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }

      if(data.couponType == 4) {
        this.prizeSettingList[this.index].price = data.price;
      } else {
        this.prizeSettingList[this.index].price = data.discount || data.singleAmount;
      }

      if(data.couponType == 4) {
        this.prizeSettingList[this.index].assetsId = null;
      } else {
        this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      }

      
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        if(data.couponType == 4) {
          this.prizeSettingList[this.index].title = "优惠券";
        } else {
          // 专属商品
          if(prizeType == 10) {
            this.prizeSettingList[this.index].title = data.itemTitle.length >= 12 ? data.itemTitle.substring(0, 12) : data.itemTitle;
            this.prizeSettingList[this.index].price = data.price;
            this.prizeSettingList[this.index].assetsId = data.id;
            this.prizeSettingList[this.index].logo = data.picUrl;
          } else {
            this.prizeSettingList[this.index].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
          }
        }
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      console.log(this.prizeSettingList, 123);
    },
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    //选择奖品弹窗
    centerVis(row) {
      if(this.isStartEdit) return;
      this.$refs.selectProduct.openDialog();
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      this.$refs.selectProduct.physicalGift(row)
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `${this.activityData.telCode}&activityType=${this.activityData.id}`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 117, // 设置宽度，单位像素
          height: 117, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
        });
      }
    },
    // 裂变  添加优惠券
    addCoupon(type) {
      if(this.isStartEdit) return;
      if (type == 1) {
        this.disabledtask = this.taskList1.map((val) => {
          return val.taskType;
        });
        if (this.taskList1.length == 4) {
          return this.$message.warning("每日任务全部类型已创建完成,请修改任务");
        }
      } else {
        this.disabledtask = this.taskList2.map((val) => {
          return val.taskType;
        });
        if (this.taskList2.length == 3) {
          return this.$message.warning("活动任务全部类型已创建完成,请修改任务");
        }
      }
      this.dailytaskFlay = true;
      this.ActivityIsAdd = false;
      // type == 1为每日任务
      this.taskSeletFlay = type == 1 ? true : false;
      console.log(this.disabledtask, 66666);
    },
    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
        // this.itemListFor.splice(i, 1);
      }
      console.log(this.mainImagelist, 4444444);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        // if (days > 90) {
        //   this.$message.warning("活动时间不得超过90天！");
        //   this.ruleForm.activityEndTime = null;
        //   this.timeOut = 0;
        //   this.timeDay = 0;
        //   return;
        // }

        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      const day = 86400000 * 60;
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          this.activityTimeValue[0] = "";
          this.ruleForm.activityStartTime = null;
          return;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 抽奖判断
    orderChange() {
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) > Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.totalMaxRewardNumber &&
        this.ruleForm.oneDayMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
      // this.$emit("saveEdit");
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      // 评价
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityType: this.activityData.id, //活动类型 23:疯狂捉娃娃 24:大家来找茬
        // condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示淘宝价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        integralParadisePrizeDTOS: [], //抽奖奖项设置
        ruleDTO: {
          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          giveTimes: this.ruleForm.giveTimes,
          faultTimes: this.ruleForm.faultTimes,
          scoreLimit: this.ruleForm.scoreLimit,
          gameTime: this.ruleForm.gameTime,
          templateType: this.ruleForm.templateType,
          templateIds: this.gameTemplateList.join(","),
        },
        taskList: [...this.taskList1, ...this.taskList2],

        activityObject: this.ruleForm.activityObject, //活动对象
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer, //新老客
        seniorGroupId: this.peopleList.join(","), //指定人群
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      };
      cardParams.integralParadisePrizeDTOS = this.prizeSettingList.map((item) => {
        let prize = {
          ...item,
          percentage: item.percentage ? item.percentage : 0,
        };
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
          prize.singleAmount = 1;
        } else if (prize.prizeType == 8) {
          prize.singleAmount = 1;
        } else {
          prize.singleAmount = parseInt(item.price * 1);
        }
        return prize;
      });
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        cardParams.itemList = b;
      }
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      let taskListArr = [...this.taskList1, ...this.taskList2];
      if (taskListArr.length != 0) {
        let taskIsflay = false;
        let activityStartTime = new Date(this.ruleForm.activityStartTime.substring(0, 10)).valueOf();
        let activityEndTime = new Date(this.ruleForm.activityEndTime.substring(0, 10)).valueOf();
        taskListArr.forEach((item) => {
          if (item.startTime) {
            let startTime = new Date(item.startTime.substring(0, 10)).valueOf();
            let endTime = new Date(item.endTime.substring(0, 10)).valueOf();
            if (startTime < activityStartTime || endTime > activityEndTime) {
              taskIsflay = true;
            }
          }
        });
        if (taskIsflay) return this.$message.warning(`任务有效期超出了活动时间范围，请重新选择`);
      }
      //请输入赠送游戏机会
      if (!this.ruleForm.giveTimes) {
        return this.$message.warning("请输入赠送游戏机会");
      }
      // 娃娃
      if (this.activityData.id == 23) {
        //请输入容错机会
        if (!this.ruleForm.faultTimes) {
          return this.$message.warning("请输入容错机会");
        }
        //请输入抽奖分值
        if (!this.ruleForm.scoreLimit) {
          return this.$message.warning("请输入抽奖分值");
        }
      }
      // 找茬
      if (this.activityData.id == 24) {
        cardParams.gameTemplateId =
          this.ruleForm.templateType == "0" ? this.giftList.map((item) => item.id).join(",") : this.gameTemplateList.join(",");

        //请输入游戏时间
        if (!this.ruleForm.gameTime) {
          return this.$message.warning("请输入游戏时间");
        }
        if (this.ruleForm.templateType == 1 && this.gameTemplateList.length == 0) {
          return this.$message.warning("请输入选择游戏模板");
        }
      }

      // // 请将奖品填写完整！
      let isFlay = false;
      this.prizeSettingList.forEach((item) => {
        if (item.prizeType != 9) {
          if (!item.price || !item.percentage || !item.totalAmount || !item.title) {
            isFlay = true;
          }
        }
      });
      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListFor.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      //活动规则不能为空
      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.valueRow && !this.isCopy) {
          editGameHub({ ...cardParams, id: this.valueRow.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit", this.activityData.id);
              this.$router.push({ path: "activeList3" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          createGameHub(cardParams).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList3" });
              // this.$emit("saveEdit", this.activityData.id);
            } else {
              this.$message.error(res.message);
            }
          });
        }

        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch(() => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //活动对象切换
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
    //选择人群回调
    handleConfirm(list) {
      console.log("选择人群", list);
      // let flag = false;
      // list.forEach((item) => {
      //   if (item.buyerNum == 0) {
      //     flag = true;
      //   }
      // });
      // if (flag) {
      //   this.$message.warning("含人群数量为0的人群，请重新选择人群");
      // }
      this.peopleList = list;
    },

    //生成规则
    generateRule() {
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      //活动规则判断
      let text1 = "",
        text2 = `2、游戏机会： 首次赠送游戏次数${this.ruleForm.giveTimes || 0}次；完成相应任务可获得游戏次数；`,
        text3 = `3、抽奖规则： 每个娃娃为10分，活动期间单次超过${this.ruleForm.scoreLimit || 0}分，参与抽奖；`,
        text4 = "4、助力好友：一名好友活动期间仅可为1名好友助力；",
        text5 = "5、奖品数量有限，先到先得；",
        text6 = "6、若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；",
        text7 = "注：奖品发放形式： 实物奖：",
        text8 = "  中奖客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放)",
        text9 =
          "  实物奖采取寄送方式发放，获奖用户需在开奖后填写姓名、联系电话、详细地址信息。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品；",
        // text10 = "虚拟产品奖：",
        // text11 = "  （1）京豆、红包、积分、淘宝E卡：中奖后系统预计24小时内自动发放至账户；",
        // text12 = "  （2）发放型优惠券：中奖后自动发放，预计24小时到账；",
        // text13 = "  （3）领取型优惠券：中奖后需手动领取，预计24小时到；",
        // text14 = "  （4）PLUS会员、爱奇艺会员卡：中奖后需手动兑换；",
        text10 = "活动参与主体资格：",
        text11 =
          "  （1）每位自然人用户仅能使用一个淘宝账号参与活动，微信号、QQ、淘宝帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。",
        text12 = "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。",
        text13 = "注意事项：",
        text14 =
          "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。",
        text15 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。",
        text16 = "  （3）本活动所发放的实物奖不得提现、不得转赠他人、不得为他人付款。",
        text17 = "  （4）是否中奖以活动发布者后台统计结果为准。",
        text18 = "";
      //活动时间
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 = "1、活动时间：" + this.ruleForm.activityStartTime + "~" + this.ruleForm.activityEndTime + ";";
      }
      let Arr1 = [];
      if (this.activityData.id == 24) {
        text2 = `2、游戏机会： 首次赠送游戏次数${this.ruleForm.giveTimes || 0}次；完成相应任务可获得游戏次数；`;
        text3 = `3、抽奖规则： 在规定的${this.ruleForm.gameTime}秒时间内找出图片中所有的不同之处，即完成通关，可参与抽奖；`;
        text4 = "4、助力好友：一名好友活动期间仅可为1名好友助力；";
        text5 = "5、奖品数量有限，先到先得；";
        text6 = "6、若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；";
        text7 = "注：奖品发放形式： 实物奖：";
        text8 = "实物奖：";
        text9 = "  (1）中奖客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放)";
        text10 =
          "  (2）实物奖采取寄送方式发放，获奖用户需在开奖后填写姓名、联系电话、详细地址信息。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品；";
        // text11 = "虚拟产品奖：";
        // text12 = "  (1）京豆、红包、积分、淘宝E卡：中奖后系统预计24小时内自动发放至账户；";
        // text13 = "  (2）发放型优惠券：中奖后自动发放，预计24小时到账；";
        // text14 = "  (3）领取型优惠券：中奖后需手动领取，预计24小时到； （4）PLUS会员、爱奇艺会员卡：中奖后需手动兑换；";
        text11 = "活动参与主体资格：";
        text12 =
          "  (1）每位自然人用户仅能使用一个淘宝账号参与活动，微信号、QQ、淘宝帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。";
        text13 = "  (2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格。";
        text14 = "注意事项：";
        text15 =
          "  （1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利。";
        text16 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动。";
        text17 = "  （3）本活动所发放的实物奖不得提现、不得转赠他人、不得为他人付款。";
        text18 = "  （4）是否中奖以活动发布者后台统计结果为准。";
      }
      Arr1 = [
        text1,
        text2,
        text3,
        text4,
        text5,
        text6,
        text34,
        text7,
        text8,
        text9,
        text10,
        text11,
        text12,
        text13,
        text14,
        text15,
        text16,
        text17,
        text18,
      ];
      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsClose(event, index) {
      // if (data) {
      //   this.itemListFor = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }

      // console.log("选择完商品===", event, index);
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }

      this.selectGoodsState = false;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    detailexplain(val, type) {
      if (type == 1) {
        let arr = ["", "每日打卡", "浏览店铺", "浏览商品", "加购商品", "浏览会场", "关注店铺", "开卡入会", "好友助力"];
        return arr[val.taskType];
      } else {
        let content = "";
        if (val.taskType != 8) {
          content =
            val.taskType === 1
              ? "点击打卡"
              : val.taskType === 2
              ? "浏览店铺"
              : val.taskType === 3
              ? `浏览商品${val.viewTime}秒`
              : val.taskType === 4
              ? `加购商品${val.addCartLimit}个`
              : val.taskType === 5
              ? "浏览会场"
              : val.taskType === 6
              ? "点击关注"
              : "成功开卡";
          return content + ",赠送1次游戏机会";
        } else {
          return `每邀请1位好友，赠送1次游戏机会，最多可邀请${val.inviteLimit}位助力`;
        }
      }
    },
    // 10的倍数
    handleLimit() {
      let res = Number(this.ruleForm.scoreLimit);
      if (res % 10 != 0) {
        this.ruleForm.scoreLimit = "";
        return this.$message.warning("请填写10的N倍的正整数");
      }
    },
    //输入框限制负数
    checkputn(value, num) {
      let filtered = value.replace(/^0|[^\d]/g, "");
      value = Number(filtered);
      if (num == "0") {
        if (value < 1) {
          value = "";
        }
      }
      if (num == "10") {
        if (value < 1 || value > 9) {
          value = "";
        }
      }
      return value
    },

    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    // 修改
    editTaskdeail(item, i, type) {
      if(this.isStartEdit) return;
      this.taskItem = Object.assign({}, item);
      if (type == 1) {
        this.edittaskIndex1 = i;
        this.disabledtask = this.taskList1
          .filter((val) => val.taskType != item.taskType)
          .map((ele) => {
            return ele.taskType;
          });
        // this.disabledtask = this.taskList1.map((val) => {
        //   if (val.taskType != item.taskType) {
        //     return val.taskType;
        //   }
        // });
      } else {
        this.edittaskIndex2 = i;
        this.disabledtask = this.taskList2
          .filter((val) => val.taskType != item.taskType)
          .map((ele) => {
            return ele.taskType;
          });
      }
      this.taskSeletFlay = type == 1 ? true : false;
      this.ActivityIsAdd = true;
      this.dailytaskFlay = true;
      console.log(this.disabledtask);
    },
    // 上移下移
    changeSort(index, type, i) {
      if(this.isStartEdit) return;
      // index 为下标 上移 type 为 0， 下移为 1.  i==1为taskList1 2为taskList2
      if (i == 1) {
        this.taskList1.splice(
          type ? index : index - 1,
          1,
          ...this.taskList1.splice(type ? index + 1 : index, 1, this.taskList1[type ? index : index - 1])
        );
      } else {
        this.taskList2.splice(
          type ? index : index - 1,
          1,
          ...this.taskList2.splice(type ? index + 1 : index, 1, this.taskList2[type ? index : index - 1])
        );
      }
    },
    changedelet(i, type) {
      if(this.isStartEdit) return;
      if (type == 1) {
        this.taskList1.splice(i, 1);
      } else {
        this.taskList2.splice(i, 1);
      }
    },
    // 每日任务  活动 新增
    handleChoice(val) {
      console.log(val, 3333333);
      if (val) {
        let isflay = false;
        if (val.taskType > 5) {
          this.taskList2.forEach((item) => {
            if (item.taskType === val.taskType) {
              isflay = true;
            }
          });
          if (isflay) return this.$message.warning("您已创建该类型任务，请重新选择~");
          this.taskList2.push(val);
        } else {
          this.taskList1.forEach((item) => {
            if (item.taskType === val.taskType) {
              isflay = true;
            }
          });
          if (isflay) return this.$message.warning("您已创建该类型任务，请重新选择~");
          this.taskList1.push(val);
        }
      }
      this.dailytaskFlay = false;
    },
    // 每日任务  活动 修改
    handleChoiceEdit(val) {
      console.log(val, 3333333);
      if (val) {
        if (val.taskType > 5) {
          this.taskList2.splice(this.edittaskIndex2, 1, val);
        } else {
          this.taskList1.splice(this.edittaskIndex1, 1, val);
        }
        this.dailytaskFlay = false;
      }
    },
    // 指定模板
    handleTemplate(val) {
      // console.log(val);
      if (val) {
        this.gameTemplateList = val.map((item) => item.id);
      }
      this.gamePopup = false;
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // if (this.activityData.id == 24) {
      //   this.$emit("returnBack");
      // } else {
      //   this.localStep = 0;
      //   this.localStepNum = 0;
      // }
      // this.ruleForm.radio = 0;
      // this.ruleForm.exposureSwitch = false;
      // this.itemListFor = [];
      // this.ruleForm.activityName = "";
      // this.ruleForm.activityStartTime = "";
      // this.ruleForm.activityEndTime = "";
      // this.ruleForm.condFollow = false; // 是否需要关注店铺
      // this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      // this.mainImagelist = []; //图片拖拽排序
      // this.isDragging = false;
      // this.itemListFor = []; //商品弹框选择商品数据
      // this.selectGoodsState = false; //曝光商品弹窗
      // this.ruleForm.activityRulesText = "";
      // this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open("https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch", "_self");
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
  },
};
</script>

<style lang="scss" scoped>
.taskbox_edit:hover {
  border-color: #2670fb;
  color: #2670fb;
}
.taskbox_del:hover {
  border-color: red;
  color: red;
}
/deep/.el-checkbox__label {
  color: #000;
}
.taskbox {
  display: flex;
  justify-content: space-between;
  &-content {
    display: flex;
    span {
      cursor: pointer;
      // padding: 0 5px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      width: 44px;
      margin-right: 4px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #666;
    }
  }
}

.inputcount {
  /deep/.el-input__count {
    display: none !important;
  }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__body-wrapper {
  // overflow: visible !important;
  overflow: auto;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #2670fb;
  }
}
.s {
  color: #2670fb;
  cursor: pointer;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 10px 30px;
  background: #f4f7ff;
  font-size: 13px;
  color: #333;
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.set {
  display: inline-block;
  // margin-top: 30px;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #2670fb;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;
  // background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-left: -72px;
  // &_middle {

  // }
  &_content {
    padding: 10px 15px 10px 25px;
    background: #f8f9ff;
    margin: 10px 0;
    // padding-top: 10px;
    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }
    p {
      padding-left: 21px;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #2670fb;
    color: #2670fb;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #2670fb;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #2670fb;
  }
  color: #999;
}

.delectPosible:hover {
  -webkit-box-shadow: #ccc 0px 1px 1px;
  -moz-box-shadow: #ccc 0px 1px 1px;
  box-shadow: #ccc 0px 1px 1px;
}
.flex {
  display: flex;
  align-items: center;
}

.add_btn1 {
  cursor: pointer;
  color: #fff;
  border: 1px solid #2670fb;
  width: 80px;
  height: 32px;
  display: flex;
  background: #2670fb;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  &:hover {
    opacity: 0.8;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #2670fb;
                border-bottom: 1px solid #2670fb;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #2670fb;
                border-left: 1px solid #2670fb;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
</style>
